module.exports = __webpack_public_path__ + "static/img/David-Fusitu_a.7a11897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/David-Fusitu_a.jpg
// module id = keO/
// module chunks = 0